module.exports = __webpack_public_path__ + "img/envestnet-yodlee.6e7c0f76.svg";